const filterOrderConfig: { [key: string]: string[] } = {
  'university-levels': ['beginner', 'intermediate', 'advanced'],
}

export const orderFilterItems = (type: string, filterItems: Array<any>) => {
  if (type in filterOrderConfig) {
    filterItems?.sort((a, b) => {
      return filterOrderConfig[type].indexOf(a.description) >
        filterOrderConfig[type].indexOf(b.description)
        ? 1
        : -1
    })
  }
  return filterItems
}
